module.exports = __webpack_public_path__ + "assets/img/year-title-icon.f1ee2793.png";